import { Module } from 'vuex'
import axios from '@/plugins/axios'

const settingsModule: Module<any, any> = {
    state: {
        authedMemberSettings: null,
    },
    actions: {
        async getPersonalSettings() {
            // let data = null
            // const headers = {
            // 	'Authorization': 'Bearer ' + rootState.auth.token
            // }
            // await axios
            // 	.get('/api/settings/member', {headers: headers})
            // 	.then(response => {
            // 		data = response.data
            // 	})
            // return data
        },
        async getWorkspaceTags() {
            // let data = null
            // const headers = {
            // 	'Authorization': 'Bearer ' + rootState.auth.token
            // }
            // await axios
            // 	.get('/api/settings/workspace_tags', {headers: headers})
            // 	.then(response => {
            // 		data = response.data
            // 	})
            // return data
        },
        async updateName(_, params) {
            await axios.put(`/api/workspace_members/${params.id}/name`, {
                firstName: params.firstName,
                lastName: params.lastName,
            })
        },
        async updatePhoneSettings(_, params) {
            await axios.put(
                `/api/workspace_members/${params.id}/phone_number`,
                { phoneNumber: params.phoneNumber },
            )
        },
        async changeRoles({ commit }, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/roles`,
                { workspaceMemberRoles: params.roles },
            )
			// Store updated member data locally
			this.dispatch('addMemberRecord', data)
            return data
        },
        async updateSettings({ commit, getters }, settings) {
             const { data } = await axios.put(
                `/api/workspace_members/${settings.id}/settings`,
                settings,
            )
            if (settings.id == getters.authedMemberInfo.id) {
	            commit('setAuthedMemberSettings', data)
            }
        },
        async updateNotificationSettings(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/notifications`,
                params.settings,
            )
            return data
        },
        async updateUsername(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/username`,
                params,
            )
            return data
        },
        async updatePassword(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/password`,
                params,
            )
            return data
        },
        async forgotPassword(_, params) {
            const { data } = await axios.post(
                '/api/workspace_members/forgot_password',
                params,
            )
            return data
        },
        async updateTag(_, tag) {
            // const headers = {
            // 	'Authorization': 'Bearer ' + rootState.auth.token
            // }
            // if (tag.value) {
            //     await axios.post('api/settings/workspace_members_tags', {workspaceTagId: tag.id}, {headers: headers})
            // } else {
            //     await axios.delete('api/settings/workspace_members_tags', {headers: headers, data: {workspaceTagId: tag.id}})
            // }
        },
    },
    getters: {
		authedMemberSettings: state => state.authedMemberSettings
    },
    mutations: {
		setAuthedMemberSettings(state, settings) {
			state.authedMemberSettings = settings
		}
    },
}

export default settingsModule
